import React from 'react';
import SideMenu from '../components/SideMenu';
import Header from '../components/Header';
import UserMenu from '../components/UserMenu';
import thumbimg from '../assets/images/thumbimg.png'

const ModifyRegReciept = () => {
  return (
    <div className="flex h-screen">
    <SideMenu />
    <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
  <div className="max-w-5xl mx-auto p-4 bg-secondary-50 rounded-md shadow-md">
    <h2 className="text-xl font-semibold mb-4">Modify Receipt</h2>


    <div className="flex flex-wrap items-start gap-4">
 
  <div className="grid grid-cols-2 gap-4 flex-grow">

    <div className="flex items-center">
      <label className="block font-semibold mr-2 w-full">From Date</label>
      <input type="date" className="w-full p-2 border rounded" />
    </div>

    <div className="flex items-center">
      <label className="block font-semibold mr-2 w-full">To Date</label>
      <input type="date" className="w-full p-2 border rounded" />
    </div>
  </div>


  <div className="mt-2 flex justify-center items-center">
    <div className="bg-white flex items-center justify-center border rounded overflow-hidden">
      <img src={thumbimg} alt="Thumb Image" className="h-20 w-20 object-cover" />
    </div>
  </div>
</div>




    <div className="mt-6 text-center">
      <button className="px-6 py-2 bg-blue-500 text-white rounded mx-6">ok</button>
    </div>
  </div>
</div>


            {/* Right Side */}
            <div className="w-64 h-full">
                <UserMenu />
            </div>
        </div>
    </div>
</div>
  )
}

export default ModifyRegReciept
